import {classes} from './css-common.st.css';

export function cssCommonExtendHitArea () {
    return classes.hitArea;
}

export function cssEllipsis () {
    return classes.ellipsis;
}

export function cssNoWrap () {
    return classes.noWrap;
}

export function cssVisibilityHidden () {
    return classes.visibilityHidden;
}

export function cssUserSelectableText () {
    return classes.userSelectableText;
}

export function cssCollapsedWhenEmpty () {
    return classes.collapsedWhenEmpty;
}

export function cssCenterChildrenInline () {
    return classes.centerChildrenInline;
}

/**
 * @depreacted use cssCenterChildrenInline instead.
 */
export function cssCenterInlineContent () {
    return classes.centerInlineContent;
}

export function cssMaxFullWidth () {
    return classes.maxFullWidth;
}

export function cssPointerEventsNone () {
    return classes.pointerEventsNone;
}

export function cssPointerEventsAll () {
    return classes.pointerEventsAll;
}

export function cssForceFullHeight () {
    return classes.fullHeight;
}

export function cssMinFullHeight () {
    return classes.minFullHeight;
}

export function cssFullWidthAndHeight () {
    return classes.fullWidthAndHeight;
}

export function cssFullScreenWidthAndHeight () {
    return classes.fullScreenWithAndHeight;
}

export function cssFullWidth () {
    return classes.fullWidth;
}

export function cssAbsoluteStretchInOffsetParent () {
    return classes.absoluteStretchInOffsetParent;
}

export function cssIsolatedStackingContext () {
    return classes.isolatedStackingContext;
}

export function cssOverlay () {
    return classes.overlay;
}

export function cssOverflowHidden () {
    return classes.overflowHidden;
}

export function cssTouchActionNone () {
    return classes.touchActionNone;
}

export function cssDraggingHandle () {
    return classes.draggingHandle;
}

export function cssFlipHorizontallyOnRtl () {
    return classes.flipHorizontallyOnRtl;
}

export function cssScreenReadersOnly (isFocusable: boolean = false) {
    return isFocusable ? classes.srOnlyFocusable : classes.srOnly;
}

export function cssGap (gap: 2 | 4 | 6 | 8 | 10 | 12 | 16 | 18 | 24) {
    switch (gap) {
        case 2: return classes.gap2;
        case 4: return classes.gap4;
        case 6: return classes.gap6;
        case 8: return classes.gap8;
        case 10: return classes.gap10;
        case 12: return classes.gap12;
        case 16: return classes.gap16;
        case 18: return classes.gap18;
        case 24: return classes.gap24;
        default: return undefined;
    }
}